import { Injectable } from "@angular/core";
import { Constants } from "../utils/constants";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ApiResponse } from "../classes/api-response";
import { map } from "rxjs/operators";
import { Items } from "../model/items";
import { BillingSetup } from "../model/billingSetup";
import { BillingItems } from "../model/billingItems";

@Injectable({
  providedIn: 'root'
})
export class BillingItemsService {

  private readonly entities = Constants.entities;
  // private readonly crtlPathFragment = this.entities.systemLogs;
  // private readonly crtlFullPath = `${environment.apiUrl}/${this.crtlPathFragment}`;
  private readonly ctrlFullPathLS = `${environment.apiUrl}/billing/all`;
  private readonly ctrlFullPathUpdate = `${environment.apiUrl}/billing/updateBillingSetup`;
  private readonly ctrlFullPathDelete = `${environment.apiUrl}/billing/delete`;
  private readonly ctrlFullPathDeleteItem = `${environment.apiUrl}/billing/deleteBillingItemById`;
  private readonly ctrlFullPathUpdateItem = `${environment.apiUrl}/billing/updateBillingItemById`;
  constructor(private http: HttpClient) {
  }

  /* public getAllSystemLogs(statuses?: string[]): Observable<SystemLogs[]> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
.get<ApiResponse>(`${this.crtlFullPath}`, {params})
       .pipe(map(value => value.data as SystemLogs[]));
  } */

  public getAllBillingItems() {
    return this.http.get<ApiResponse>(`${this.ctrlFullPathLS}`)
      .pipe(map(value => value.data as Items[]
      ))
  }

  public getAllBillingItemsByCompany(companyId?: number) {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/billing/${this.entities.companies}/${companyId}/billingItems`)
      .pipe(map(value => value.data as Items[]
      ))
  }

  public updateBillingSetup(billingSetup: BillingSetup): Observable<BillingSetup> {
    return this.http
      .post<ApiResponse>(`${this.ctrlFullPathUpdate}/${billingSetup.id}`, billingSetup)
      .pipe(map((value => value.data as BillingSetup)))
  }

  public deleteBillingSetup(id: number): Observable<void> {
    return this.http
      .delete<ApiResponse>(`${this.ctrlFullPathDelete}/${id}`)
      .pipe(map(() => {
      }));
  }

  public deleteItem(id: number): Observable<void> {
    return this.http
      .delete<ApiResponse>(`${this.ctrlFullPathDeleteItem}/${id}`)
      .pipe(map(() => {
      }));
  }

  public updateItem(billingItem: BillingItems): Observable<void> {
    console.log(billingItem);
    return this.http
      .post<ApiResponse>(`${this.ctrlFullPathUpdateItem}/${billingItem.id}`, billingItem)
      .pipe(map(() => {
      }));
  }

}

